import { Button, Icon, Panes, Tabs } from '@wtfalch/design';
import type { MailboxNode, MailClient, VacationResponse } from '@wtfalch/email/mailbox';

import { Away } from './Away.tsx';
import { Rules } from './Rules.tsx';
import { Scheduled } from './Scheduled.tsx';
import { Sharing } from './Sharing.tsx';

export type MailSettingsTab = 'away' | 'sharing' | 'rules' | 'scheduled';

const TABS: { id: MailSettingsTab; label: string }[] = [
  { id: 'away', label: 'Away reply' },
  { id: 'sharing', label: 'Sharing' },
  { id: 'rules', label: 'Rules' },
  { id: 'scheduled', label: 'Scheduled' },
];

/** The mail settings pane: opens in place of the list and the reader, the
 *  way the composer does, with one tab per area. */
export function MailSettings({
  client,
  tab,
  onTab,
  onClose,
  tree,
  onTreeChange,
  onAwayChange,
}: {
  client: MailClient;
  tab: MailSettingsTab;
  onTab: (tab: MailSettingsTab) => void;
  onClose: () => void;
  onAwayChange: (response: VacationResponse) => void;
  tree: readonly MailboxNode[] | null;
  onTreeChange: (tree: readonly MailboxNode[]) => void;
}) {
  return (
    <Panes.Column flex className="mail-reader">
      <div className="flex items-center gap-3 mail-compose-head">
        <h2 className="h3 m-0">Mail settings</h2>
        <div className="grow min-w-0" />
        <Button kind="ghost" size="sm" iconOnly aria-label="Close settings" onPress={onClose}>
          <Icon name="close" size={18} />
        </Button>
      </div>
      <div className="flex flex-1 flex-col overflow-y-auto mail-set">
        <Tabs
          label="Mail settings"
          tabs={TABS}
          value={tab}
          onChange={(id) => onTab(id as MailSettingsTab)}
        />
        <div className="mail-set-body">
          {tab === 'away' && <Away client={client} onChange={onAwayChange} />}
          {tab === 'rules' && <Rules client={client} tree={tree} />}
          {tab === 'sharing' && <Sharing client={client} tree={tree} onTreeChange={onTreeChange} />}
          {tab === 'scheduled' && <Scheduled client={client} />}
        </div>
      </div>
    </Panes.Column>
  );
}
